<div class="container" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign.gt-md="space-around center" fxLayoutGap="50px">

    <mat-card *ngIf="dish" fxFlex [@expand]>
        <mat-card-header>
            <div mat-card-avatar></div>
            <mat-card-title>
                <h3>{{dish.name | uppercase}}</h3>
            </mat-card-title>
        </mat-card-header>
        <img height="320px" mat-card-image src="{{ BaseURL+dish.image }}" alt={{dish.name}}>
        <mat-card-content>
            <p class="description">{{dish.description}}
            </p>
        </mat-card-content>
    </mat-card>
    <div fxFlex [hidden]="dish || dishErrMess" [@expand]>
        <mat-spinner></mat-spinner>
        <h4>Loading . . . Please Wait</h4>
    </div>
    <div fxFlex *ngIf="dishErrMess" [@expand]>
        <h2 style="text-align: center;">Error</h2>
        <h4>{{dishErrMess}}</h4>
    </div>
    <mat-card *ngIf="promotion " fxFlex [@expand]>
        <mat-card-header>
            <div mat-card-avatar></div>
            <mat-card-title>
                <h3>{{promotion.name | uppercase}}</h3>
            </mat-card-title>
        </mat-card-header>
        <img height="320px" mat-card-image src="{{BaseURL + promotion.image}}" alt={{promotion.name}}>
        <mat-card-content>
            <p class="description">{{promotion.description}}
            </p>
        </mat-card-content>
    </mat-card>
    <div fxFlex [hidden]="promotion || promotionErrMess " [@expand]>
        <mat-spinner></mat-spinner>
        <h4>Loading . . . Please Wait</h4>
    </div>
    <div fxFlex *ngIf="promotionErrMess" [@expand]>
        <h2 style="text-align: center;">Error</h2>
        <h4>{{promotionErrMess}}</h4>
    </div>

    <mat-card *ngIf="leader" fxFlex [@expand]>
        <mat-card-header>
            <div mat-card-avatar></div>
            <mat-card-title>
                <h3>{{leader.name | uppercase}} {{leader.abbr}}</h3>
            </mat-card-title>
        </mat-card-header>
        <img height="320px" mat-card-image src="{{BaseURL  + leader.image}}" alt={{leader.name}}>
        <mat-card-content>
            <p style="font-size: 80%;text-align: center;font-weight: 500;">{{leader.designation}}
            </p>
            <p style="font-size: 80%;">{{leader.description}}
            </p>
        </mat-card-content>
    </mat-card>
    <div fxFlex [hidden]="leader || leaderErrMess" [@expand]>
        <mat-spinner></mat-spinner>
        <h4>Loading . . . Please Wait</h4>
    </div>
    <div fxFlex *ngIf="leaderErrMess" [@expand]>
        <h2 style="text-align: center;">Error</h2>
        <h4>{{leaderErrMess}}</h4>
    </div>

</div>